import _some from "lodash/some";
import _keyBy from "lodash/keyBy";
import _mapValues from "lodash/mapValues";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';

// Returns { perTech, any } for the given sampleTechs:
//  - perTech: { [sampleTech]: boolean }, whether the experiment has at least one sample
//    of that tech
//  - any: whether the experiment has a sample of at least one of the given techs
// All values are null while the sample ids aren't loaded yet.
var getHasSampleTech = function getHasSampleTech(experimentId, sampleTechs) {
  return function (state) {
    var _state$experiments$ex, _state$experiments$ex2;
    var toPerTech = function toPerTech(getValue) {
      return _mapValues(_keyBy(sampleTechs), getValue);
    };
    var sampleIds = (_state$experiments$ex = (_state$experiments$ex2 = state.experiments[experimentId]) === null || _state$experiments$ex2 === void 0 ? void 0 : _state$experiments$ex2.sampleIds) !== null && _state$experiments$ex !== void 0 ? _state$experiments$ex : state.experimentSettings.info.sampleIds;
    if (!sampleIds) return {
      perTech: toPerTech(function () {
        return null;
      }),
      any: null
    };
    var presentTechs = new Set(sampleIds.map(function (sampleId) {
      var _state$samples$sample;
      return (_state$samples$sample = state.samples[sampleId]) === null || _state$samples$sample === void 0 ? void 0 : _state$samples$sample.type;
    }));
    var perTech = toPerTech(function (sampleTech) {
      return presentTechs.has(sampleTech);
    });
    return {
      perTech: perTech,
      any: _some(perTech)
    };
  };
};
export default createMemoizedSelector(getHasSampleTech);